<template>
	<!-- 统计分析 企业隐患排查统计 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
			
        	<el-form-item>
				<el-input v-model="filters.coName" placeholder="企业名称"></el-input>
			</el-form-item>
        
			<el-form-item>
				<el-button type="primary" v-on:click="getSelfCheckSumListPage">查询</el-button>
			</el-form-item>
			
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="companylist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			
      		<el-table-column prop="coName" label="企业名称"  align="center" min-width="200">
		 	</el-table-column>

       		<el-table-column prop="cityName" label="所属城市" align="center" min-width="100">
			</el-table-column>

			<el-table-column prop="recordcount" label="隐患排查记录数量" align="center"  min-width="100">
			</el-table-column>

			<el-table-column prop="reportcount" label="重大隐患上报数量" align="center"  min-width="100">
			</el-table-column>
     
			<el-table-column label="操作" align="center" width="300">
				<template slot-scope="scope">
					<el-button  type="primary" size="small" @click="handleRecordDetail(scope.$index, scope.row)">排查统计</el-button>
					<el-button  type="warning" size="small" @click="handleReportDetail(scope.$index, scope.row)">上报统计</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>


		 <!--明细界面-->
		 <el-dialog :title="detailFormTitle"  v-model="detailFormVisible" :close-on-click-modal="false">

			<el-row>
				<el-col >
				<div >
					<label>企业名称:  {{detailForm.companyName}}</label>
				</div>
				</el-col>
			</el-row>
			

	  	<el-table :data="feedata" highlight-current-row v-loading="feelistLoading">
			<el-table-column prop="createTime" label="月份" align="center"  min-width="150">
			</el-table-column>
			<el-table-column prop="mcount" label="记录数量" align="center"  min-width="120">
			</el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total,prev, pager, next" @current-change="handletypeChange"
          :page-size="5" :total="feetotal" style="float:right;"
        ></el-pagination>
      </el-col>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="detailFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
		
	</section>
</template>

<script>
	import {selfcheckSumPage,reportMonthPage,recordMonthPage} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id

				filters: {
					coName:"",
				},
				companylist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//明细
				detailFormVisible: false,
				detailFormTitle:'',  //对话框名称
				detailForm: {
					companyName: "",
				},
				qType:"0", //0记录统计1上报统计
				qcoId:0, //当前查看的企业id
				feedata: [],
				feetotal: 0,
				feepage: 1,
				feelistLoading: false,
				
			}
		},
		methods: {
			
			handleCurrentChange(val) {				
				this.page = val;
				this.getSelfCheckSumListPage();
			},
			//获取列表
			getSelfCheckSumListPage() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.coName
				};

				this.listLoading = true;

				selfcheckSumPage(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companylist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			handleReportDetail: function (index, row) {
				this.detailFormVisible=true
				this.detailFormTitle = "企业重大隐患上报 按月统计"  
				
				this.detailForm.companyName=row.coName
				this.qcoId=row.coId
				this.feepage=1
				this.qType="1"
				this.getReportMonthPage()
			
			},
			
			handleRecordDetail: function (index, row) {
				this.detailFormVisible=true
				this.detailFormTitle = "企业隐患排查记录 按月统计"  

				this.detailForm.companyName=row.coName

				this.qcoId=row.coId
				this.feepage=1
				this.qType="0"
				this.getRecordMonthPage()
			},
			//
			getRecordMonthPage() {
				
				let para = {
					page: this.feepage,
					pageSize:5,
					coId:this.qcoId,
				};

				this.feelistLoading = true;

				recordMonthPage(para).then((res) => {
					if(res.data.code==0){
						this.feetotal = res.data.data.total;
						this.feedata = res.data.data.list;
					}
					
					this.feelistLoading = false;

				});
			},
			getReportMonthPage() {
				
				let para = {
					page: this.feepage,
					pageSize:5,
					coId:this.qcoId,
				};

				this.feelistLoading = true;

				reportMonthPage(para).then((res) => {
					if(res.data.code==0){
						this.feetotal = res.data.data.total;
						this.feedata = res.data.data.list;
					}
					
					this.feelistLoading = false;

				});
			},
			handletypeChange(val) {
				this.feepage = val;

				if (this.qType=="0") {
					this.getRecordMonthPage();
				} else {
					this.getReportMonthPage();
				}
			
			},
			
		
			
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.getSelfCheckSumListPage();
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// selfcheckForm.vue?4e4907d3